import { Images } from '@/assets/images';
import { Theme } from '@/theme';
import styled from 'styled-components';

export const PageContainer = styled.div`
  background-color: ${Theme.color.white};
  flex-direction: column;
  position: relative;

  min-height: 100vh;
  display: flex;
  width: 100%;
`;

export const Hero = styled.div`
  background: radial-gradient(50% 50% at 50% 50%, #f5783a 0%, #db0007 100%);
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
  height: 356px;
  width: 100%;
  overflow: hidden;
  margin-bottom: ${Theme.rems(18)};
`;

export const HeroContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  &::after {
    content: '';
    background-image: url(${Images.Avatars});
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 0;
  }
`;

export const HeroLogo = styled.img`
  position: relative;
  height: auto;
  z-index: 2;
`;
